import React, { useState, useEffect } from "react";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { Breadcrumb } from "react-bootstrap";
import Loader from "../Common/Loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { DateRangePicker, createStaticRanges } from "react-date-range";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Box,
  Avatar,
  IconButton,
  Tooltip,
  MenuItem,
  DialogActions,
  Select,
  InputLabel,
  DialogContent,
  FormControl,
  DialogTitle,
  Dialog,
  ListItemText,
  Checkbox,
  Chip,
  Switch,
  FormControlLabel,
  OutlinedInput,
  Paper,
  Divider,
} from "@mui/material";
import "./AssignLocationToStaff.css";
import { apiRequest } from "../../services/api";
import { encryptData } from "../Common/encryptionUtils";
import { use } from "react";
import Shimmer from "../Common/Shimmer";
import {
  addDays,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
} from "date-fns";
import { AccessLog } from "../../Utils/AccessLog";

const AssignLocationToStaff = () => {
  const [startDate, setStartDate] = useState(moment().startOf("week"));
  const [shiftDetails, setShiftDetails] = useState([]);
  const [allstaffIds, setAllstaffIds] = useState([]);
  const [publishStatus, setPublishStatus] = useState(false);
  const [lockStatus, setLockStatus] = useState(false);

  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [addShiftOpen, setAddShiftOpen] = useState(false);
  const [editShiftOpen, setEditShiftOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedStaff, setSelectedStaff] = useState("");
  const [selectedAddStaff, setSelectedAddStaff] = useState([]);
  const [selectedStaffList, setSelectedStaffList] = useState([]);

  const [selectedDateStr, setSelectedDateStr] = useState("");
  const [selectedShift, setSelectedShift] = useState([]);
  const [selectedShiftIds, setSelectedShiftIds] = useState([]);
  const [previousShifts, setPreviousShifts] = useState([]);
  const [workShiftTemplates, setWorkShiftTemplates] = useState([]);
  const authToken = localStorage.getItem("authToken");
  const selectedTopBarPremises = JSON.parse(
    localStorage.getItem("selectedTopBarPremises")
  );

  console.log("workShiftTemplates--->", workShiftTemplates);

  const userDummyImage =
    "https://businesstime.app/business-i_backend_uat/public/uploads/dummyuser.png";

  const handleNextWeek = () => {
    setStartDate((prev) => moment(prev).add(7, "days"));
  };

  const handlePrevWeek = () => {
    setStartDate((prev) => moment(prev).subtract(7, "days"));
  };

  const getWeekDates = () => {
    return Array.from({ length: 7 }).map((_, i) =>
      moment(startDate).add(i, "days")
    );
  };

  const handleAddShift = (userData, date) => {
    // alert(`Add shift for ${userName} on ${date}`);
    console.log("userData-->", userData);
    setSelectedUser(userData?.user_id);
    setSelectedStaff(userData?.staff_id);
    const formattedDate = moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    console.log("selectedDateStr-->", formattedDate);
    setSelectedDateStr(formattedDate);
    setAddShiftOpen(true);
  };

  const handleEditShift = (user, dateStr) => {
    console.log("LocatData--->", user);
    // Find the shift entry matching the clicked date
    const dateShiftEntry = user.location_details;
    setPreviousShifts(dateShiftEntry);
    console.log("dateShiftEntry--->", dateShiftEntry);

    // If found, extract the shift template IDs
    const shiftIds = dateShiftEntry
      ? dateShiftEntry.map((slot) => slot.geofence_work_location_templates_id)
      : [];

    console.log("shiftIdsData--->", shiftIds);
    // Set state
    setSelectedShiftIds(shiftIds);
    setSelectedUser(user?.user_id);
    setSelectedStaff(user?.staff_id);
    setSelectedDateStr(dateStr);

    // Open the dialog
    setEditShiftOpen(true);
  };

  console.log("selectedShift--->", selectedShift);

  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );

  const navigate = useNavigate();

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      setSelectedPremise(selected);
      if (selected?.work_location_feature == "false") {
        navigate("/dashboard");
      } else {
        console.log("selected-->", selected);
        fetchShiftTemplates(selected?.value);
        initialFetchShiftDetails(selected?.value);
      }
    }
  };

  const handleSaveShift = () => {
    setAddShiftOpen(false);
    addWorkShift();
  };

  const handleUpdateShift = () => {
    const selectedShiftObjects = workShiftTemplates.filter((shift) =>
      selectedShiftIds.includes(shift.geofence_work_location_templates_id)
    );

    console.log("Selectedshiftdata:", selectedShiftObjects); // 👉 you get full objects here
    console.log("previousShifts--->", previousShifts);

    const slotMap = new Map();
    previousShifts?.forEach((slot) => {
      slotMap.set(slot.geofence_work_location_templates_id, slot);
    });

    const updateWorkShiftPayload = [];

    selectedShiftObjects.forEach((template) => {
      const matchedSlot = slotMap.get(
        template.geofence_work_location_templates_id
      );
      console.log("matchedSlot--->", matchedSlot);
      if (matchedSlot) {
        // Template exists in slots => "accepted"
        updateWorkShiftPayload.push({
          staff_geofence_work_locations_id: encryptData(
            matchedSlot.staff_geofence_work_locations_id?.toString()
          ),
          geofence_work_location_templates_id: encryptData(
            template.geofence_work_location_templates_id?.toString()
          ),
          status: encryptData("enabled"),
        });

        // Remove from slotMap to track remaining (for "rejected")
        slotMap.delete(template.geofence_work_location_templates_id);
      } else {
        // Template does not exist in slots => "new"
        updateWorkShiftPayload.push({
          staff_geofence_work_locations_id: encryptData(""),
          geofence_work_location_templates_id: encryptData(
            template.geofence_work_location_templates_id?.toString()
          ),
          status: encryptData("enabled"),
        });
      }
    });

    // Remaining slots in slotMap are "rejected"
    for (const slot of slotMap.values()) {
      updateWorkShiftPayload.push({
        staff_geofence_work_locations_id: encryptData(
          slot.staff_geofence_work_locations_id?.toString()
        ),
        geofence_work_location_templates_id: encryptData(
          slot.geofence_work_location_templates_id?.toString()
        ),
        status: encryptData("disabled"),
      });
    }

    console.log("finalResult--->", updateWorkShiftPayload);

    if (updateWorkShiftPayload.length > 0) {
      updateWorkShift(updateWorkShiftPayload);
    }

    // You can now send this data to the backend or store it in state
    setSelectedShift(selectedShiftObjects);
    setEditShiftOpen(false);
  };

  const handleRemoveShift = (userName, date, shiftIndex) => {
    console.log(`Remove shift #${shiftIndex} for ${userName} on ${date}`);
    // Remove logic goes here
  };

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null); // { user, date, index }

  const handleOpenDeleteConfirm = (user, date, index) => {
    setDeleteTarget({ user, date, index });
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    const { user, date, index } = deleteTarget;
    // Your actual delete logic here
    console.log(`Deleted shift ${index} for ${user} on ${date}`);
    setDeleteDialogOpen(false);
    setDeleteTarget(null);
  };

  console.log("selectedShiftIds--->", selectedShiftIds);

  const fetchShiftDetails = async () => {
    // setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const startDate1 = startDate.format("YYYY-MM-DD");
      const endDate = moment(startDate).add(6, "days").format("YYYY-MM-DD");

      console.log("startDate-->", startDate);

      const payload = {
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
        start_date: encryptData(startDate1?.toString()),
        end_date: encryptData(endDate?.toString()),
      };
      const apiResponse = await apiRequest(
        `api/user/getGeofenceWorkLocationsByPremiseId?premise_id=${encryptData(
          selectedTopBarPremises?.value?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        apiResponse?.data?.status_code === 200 &&
        apiResponse?.data?.data?.user_geo_work_location_details
      ) {
        if (
          apiResponse?.data?.data?.user_geo_work_location_details?.length > 0
        ) {
          const allUserShiftDetails =
            apiResponse?.data?.data?.user_geo_work_location_details;
          console.log("allUserShiftDetails-->", allUserShiftDetails);
          setShiftDetails(allUserShiftDetails);
          const staffIds = allUserShiftDetails.map((item) => item.staff_id);
          setAllstaffIds(staffIds);
          setPublishStatus(apiResponse?.data?.data?.is_publish);
          setLockStatus(apiResponse?.data?.data?.is_locked);
        } else {
          console.log("allUserShiftDetails111-->");
          setShiftDetails([]);
        }
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      // setLoading(false);
    }
  };

  const initialFetchShiftDetails = async (premiseId) => {
    setLoading(true);
    try {
      console.log("PremiseId--->", premiseId);
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const startDate1 = startDate.format("YYYY-MM-DD");
      const endDate = moment(startDate).add(6, "days").format("YYYY-MM-DD");

      console.log("startDate-->", startDate);

      const apiResponse = await apiRequest(
        `api/user/getGeofenceWorkLocationsByPremiseId?premise_id=${encryptData(
          premiseId?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        apiResponse?.data?.status_code === 200 &&
        apiResponse?.data?.data?.user_geo_work_location_details
      ) {
        if (
          apiResponse?.data?.data?.user_geo_work_location_details?.length > 0
        ) {
          const allUserShiftDetails =
            apiResponse?.data?.data?.user_geo_work_location_details;
          console.log("allUserShiftDetails-->", allUserShiftDetails);
          setShiftDetails(allUserShiftDetails);
          const staffIds = allUserShiftDetails.map((item) => item.staff_id);
          setAllstaffIds(staffIds);
          setPublishStatus(apiResponse?.data?.data?.is_publish);
          setLockStatus(apiResponse?.data?.data?.is_locked);
        } else {
          setShiftDetails([]);
        }
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      setLoading(false);
    }
  };

  const fetchShiftTemplates = async (premise_id) => {
    // setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const apiResponse = await apiRequest(
        `api/user/getWorkLocationsTemplateByPremiseId?premise_id=${encryptData(
          premise_id?.toString()
        )}`,
        "GET",
        null,
        headers
      );

      if (
        apiResponse?.data?.status_code === 200 &&
        apiResponse?.data?.data?.user_geo_work_location_templates_details
      ) {
        if (
          apiResponse?.data?.data?.user_geo_work_location_templates_details
            ?.length > 0
        ) {
          const mappedShifts =
            apiResponse?.data?.data?.user_geo_work_location_templates_details.map(
              (work) => {
                return {
                  ...work,
                  location: `${work?.latitude},${work?.longitude}`,
                };
              }
            );
          setWorkShiftTemplates(mappedShifts);
        } else {
          setWorkShiftTemplates([]);
        }
      } else {
        setWorkShiftTemplates([]);
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      // setLoading(false);
    }
  };

  const addWorkShift = async () => {
    // setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const payload = {
        premise_id: encryptData(selectedTopBarPremises?.value?.toString()),
        user_id: encryptData(selectedUser?.toString()),
        shift_start_date: encryptData(selectedDateStr?.toString()),
        shift_end_date: encryptData(selectedDateStr?.toString()),
        ArrayOfUser_shift_templates_id: selectedShiftIds,
      };

      const apiResponse = await apiRequest(
        "/api/user/addSchedulerDetailsToUserId",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        await fetchShiftDetails();
        toast.success(apiResponse?.data?.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      // setLoading(false);
      setSelectedShift([]);
      setSelectedShiftIds([]);
      setSelectedUser("");
      setSelectedStaff("");
    }
  };

  const updateWorkShift = async (updateWorkShiftPayload) => {
    // setLoading(true);
    console.log("selectedStaff--->", selectedStaff);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const payload = {
        arrayofstaff_id: [
          {
            staff_id: encryptData(selectedStaff?.toString()),
            staff_geofence_work_locations: updateWorkShiftPayload,
          },
        ],
      };

      const apiResponse = await apiRequest(
        "/api/user/addStaffGeofenceWorkLocation",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        await fetchShiftDetails();
        console.log("selectedShiftIds--->", selectedShiftIds);
        if (selectedShiftIds?.length == 0) {
          toast.success("Assigned locations removed successfully", {
            position: "top-right",
            autoClose: 4000,
          });
        } else {
          toast.success("Location assigned successfully", {
            position: "top-right",
            autoClose: 4000,
          });
        }
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      // setLoading(false);
      setSelectedShift([]);
      setSelectedShiftIds([]);
    }
  };

  useEffect(() => {
    initialFetchShiftDetails(selectedTopBarPremises?.value);
  }, [startDate]);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [open, setOpen] = useState(false);
  const [createShiftOpen, setCreateShiftOpen] = useState(false);
  const [staffList, setStaffList] = useState([]);
  const [assignedShifts, setAssignedShifts] = useState({});
  const [assignedCreateShifts, setAssignedCreateShifts] = useState({});
  const [searchStaff, setSearchStaff] = useState("");

  const handleShiftChange = (staffId, shiftId) => {
    setAssignedShifts((prev) => ({
      ...prev,
      [staffId]: { ...prev[staffId], shiftId },
    }));
  };

  const handleEditToggle = (staffId, canEdit) => {
    setAssignedShifts((prev) => ({
      ...prev,
      [staffId]: { ...prev[staffId], canEdit },
    }));
  };

  const addStaffShiftAPI = async (staffShiftData) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      console.log("staffShiftData-->", staffShiftData);

      const payload = {
        ArrayofCreateShiftForStaff: staffShiftData,
      };

      const apiResponse = await apiRequest(
        "/api/user/addDefaultShiftForStaff",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        await fetchShiftDetails();
        toast.success(apiResponse?.data?.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      setLoading(false);
      setSelectedShift([]);
      setSelectedShiftIds([]);
      setSelectedUser("");
      setSelectedStaffList([]);
      setAssignedShifts({});
    }
  };

  const [actionType, setActionType] = useState("");
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmCreateShiftDialogOpen, setConfirmCreateShiftDialogOpen] =
    useState(false);
  const [pendingShiftData, setPendingShiftData] = useState([]); // To store data before confirm

  const [infoDialogOpen, setInfoDialogOpen] = useState(false);

  const handlePublishOrLock = (type) => {
    if (shiftDetails?.length === 0) {
      toast.info(
        "No staff have been assigned to the shift. Please add staff.",
        {
          position: "top-right",
          autoClose: 7000,
        }
      );
      return;
    }
    setActionType(type);
    if (type == "publish") {
      if (publishStatus == "true") {
        toast.info("Shifts are already published", {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        setConfirmDialogOpen(true);
      }
    } else {
      if (lockStatus == "true") {
        toast.info("Shifts are already locked", {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        setConfirmDialogOpen(true);
      }
    }
  };

  console.log("publishStatus--->", publishStatus);

  const publishOrLockShiftsAPI = async (type) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      const startDate1 = startDate.format("YYYY-MM-DD");
      const endDate = moment(startDate).add(6, "days").format("YYYY-MM-DD");

      const payload = {
        ArrayOfstaff_id: allstaffIds,
        start_date: encryptData(startDate1?.toString()),
        end_date: encryptData(endDate?.toString()),
        type: encryptData(type?.toString()), //publish or lock
      };

      const apiResponse = await apiRequest(
        "/api/user/publishLockScheduledShift",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        await fetchShiftDetails();
        toast.success(apiResponse?.data?.message, {
          position: "top-right",
          autoClose: 2000,
        });
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      setLoading(false);
      setSelectedShift([]);
      setSelectedShiftIds([]);
      setSelectedUser("");
      setSelectedStaff("");
    }
  };

  const formatDateValue = (date) => {
    const day = date.getDate().toString().padStart(2, "0"); // Adds leading zero if day < 10
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Adds leading zero if month < 10
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const createDefaultShiftAPI = async (arrayOfStaffShiftDetails) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };

      console.log("staffShiftData-->", arrayOfStaffShiftDetails);

      const payload = {
        start_date: encryptData(formatDateValue(dateRange[0].startDate)),
        end_date: encryptData(formatDateValue(dateRange[0].endDate)),
        arrayOfStaffShiftDetails: arrayOfStaffShiftDetails,
      };

      const apiResponse = await apiRequest(
        "/api/user/createDefaultShiftForStaff",
        "POST",
        payload,
        headers
      );

      if (apiResponse?.data?.status_code === 200) {
        await fetchShiftDetails();
        toast.success(apiResponse?.data?.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        const errorMessage =
          apiResponse?.data?.message || "Something went wrong.";
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.error("Error fetching shift templates", error);
      toast.error("Failed to fetch shift templates");
    } finally {
      setLoading(false);
      setSelectedAddShiftUsers([]);
      setOverrideShifts(false);
    }
  };

  useEffect(() => {
    if (staffList.length) {
      const initialShifts = {};
      staffList.forEach((staff) => {
        initialShifts[staff.staff_id] = {
          shiftId: workShiftTemplates[0]?.user_shift_templates_id || "",
          canEdit: false,
        };
      });
      setAssignedShifts(initialShifts);
    }
  }, [staffList, workShiftTemplates]);

  const handleCreateShiftChange = (staffId, shiftId) => {
    setAssignedCreateShifts((prev) => ({
      ...prev,
      [staffId]: { ...prev[staffId], shiftId },
    }));
  };

  const handleStaffCheckboxChange = (id) => {
    setSelectedAddStaff((prev) =>
      prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id]
    );
  };

  const handleStaffSelectAll = (checked) => {
    setSelectedAddStaff(checked ? staffList.map((s) => s.staff_id) : []);
  };

  const isAllSelected =
    staffList.length > 0 && selectedAddStaff.length === staffList.length;

  const handleSubmit = () => {
    const staffShiftData = selectedAddStaff.map((id) => ({
      staff_id: encryptData(id.toString()),
      default_template_id: encryptData(
        assignedShifts[id]?.shiftId?.toString() || ""
      ),
      can_edit: encryptData(assignedShifts[id]?.canEdit?.toString() || "false"),
      max_hours: encryptData("8"),
    }));

    console.log("Assigned Shifts:", staffShiftData);
    setOpen(false);
    addStaffShiftAPI(staffShiftData);
  };

  const filteredStaff = staffList.filter((staff) =>
    staff.user_name.toLowerCase().includes(searchStaff.toLowerCase())
  );

  console.log("staffList--->", staffList);

  // Simulating an API call to fetch work shift templates
  useEffect(() => {
    fetchShiftTemplates(selectedTopBarPremises?.value);
    AccessLog("Assign Locations");
  }, []);

  const [selectedAddShiftUsers, setSelectedAddShiftUsers] = useState([]);

  // ✅ Check if user is already selected
  const isUserSelected = (id) => {
    return selectedAddShiftUsers.some((user) => user.staff_id === id);
  };

  const handleUserCheck = (userObj, checked) => {
    setSelectedAddShiftUsers(
      (prev) =>
        checked
          ? [...prev, userObj] // ✅ Add full object
          : prev.filter((user) => user.staff_id !== userObj.staff_id) // ✅ Remove by ID
    );
  };

  // ✅ Select all users
  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedAddShiftUsers(shiftDetails); // Add all user objects
    } else {
      setSelectedAddShiftUsers([]); // Clear all
    }
  };

  useEffect(() => {
    const initialAssigned = {};
    selectedAddShiftUsers.forEach((staff) => {
      initialAssigned[staff.staff_id] = {
        shiftId: staff.default_template_id, // 👈 use default_template_id
      };
    });
    setAssignedCreateShifts(initialAssigned);
  }, [selectedAddShiftUsers]);

  console.log("selectedAddShiftUsers--->", selectedAddShiftUsers);

  // Create Shift

  const [overrideShifts, setOverrideShifts] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleCreateShift = () => {
    if (selectedAddShiftUsers.length === 0) {
      toast.info("Please select at least one staff member to create a shift.", {
        position: "top-right",
        autoClose: 4000,
      });
    } else {
      setCreateShiftOpen(true);
    }
  };

  const [dateRange, setDateRange] = useState([
    {
      startDate: addDays(new Date(), 1), // Tomorrow
      endDate: endOfWeek(new Date(), { weekStartsOn: 0 }), // Saturday as last date of this week
      key: "selection",
    },
  ]);

  const [tempDateRange, setTempDateRange] = useState([...dateRange]);

  // Apply selected range from temp to actual
  const handleApplyDatePicker = () => {
    setDateRange(tempDateRange);
    setShowDatePicker(false);
  };

  // Close popup without saving
  const handleCloseDatePicker = () => {
    setTempDateRange([...dateRange]);
    setShowDatePicker(false);
  };

  const handleCreateShiftSubmit = () => {
    if (selectedAddShiftUsers.length === 0) {
      toast.info("Please select at least one staff member to create a shift.", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }

    const arrayOfStaffShiftDetails = selectedAddShiftUsers.map((staff) => {
      const assigned = assignedCreateShifts[staff.staff_id];

      return {
        staff_id: encryptData(staff.staff_id?.toString()),
        default_template_id:
          encryptData(assigned?.shiftId?.toString()) ||
          encryptData(staff.default_template_id?.toString()) ||
          encryptData(""),
        is_override: encryptData(overrideShifts?.toString()),
      };
    });

    // Store data temporarily and show confirmation
    setPendingShiftData(arrayOfStaffShiftDetails);
    setConfirmCreateShiftDialogOpen(true);
  };

  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, "0"); // Adds leading zero if day < 10
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Adds leading zero if month < 10
    const year = date.getFullYear();
    const dateFormat =
      selectedTopBarPremises?.date_format === "d-m-Y"
        ? `${day}-${month}-${year}`
        : `${month}-${day}-${year}`;
    return dateFormat;
  };

  const today = new Date();

  const tomorrow = addDays(today, 1);

  const customStaticRanges = createStaticRanges([
    {
      label: "This Week",
      range: () => ({
        startDate: tomorrow,
        endDate: endOfWeek(tomorrow, { weekStartsOn: 1 }), // week ends on Sunday
      }),
    },
    {
      label: "This Month",
      range: () => ({
        startDate: tomorrow,
        endDate: endOfMonth(tomorrow),
      }),
    },
  ]);

  const handleAddStaffWithShift = () => {
    if (workShiftTemplates.length === 0) {
      toast.info(
        "No shifts have been defined. Please create a shift before assigning staff.",
        {
          position: "top-right",
          autoClose: 6000,
        }
      );
    } else {
      setOpen(true);
    }
  };

  console.log("staffListAPI--->", staffList);

  const shiftDetailsData = [
    {
      user_id: 3,
      user_name: "Martin James",
      staff_id: 3,
      location_details: [
        {
          staff_geofence_work_locations_id: 1,
          location_name: "skein tech",
          location_color: "#fffedd",
          latitude: "37.38258044696899",
          longitude: "-121.96942897515585",
          status: "enabled",
        },
        {
          staff_geofence_work_locations_id: 2,
          location_name: "vj business",
          location_color: "#dfeewd",
          latitude: "25.258863321225963",
          longitude: "55.365180433851215",
          status: "enabled",
        },
      ],
    },
    {
      user_id: 5,
      user_name: "Vinitha S",
      staff_id: 11,
      location_details: [
        {
          staff_geofence_work_locations_id: 3,
          location_name: "Justlogix",
          location_color: "#eeeewd",
          latitude: "25.258863321225963",
          longitude: "55.365180433851215",
          status: "enabled",
        },
        {
          staff_geofence_work_locations_id: 4,
          location_name: "Black pokea",
          location_color: "#egxewd",
          latitude: "25.258863321225963",
          longitude: "55.365180433851215",
          status: "enabled",
        },
        {
          staff_geofence_work_locations_id: 4,
          location_name: "Black pokea",
          location_color: "#egxewd",
          latitude: "25.258863321225963",
          longitude: "55.365180433851215",
          status: "enabled",
        },
        {
          staff_geofence_work_locations_id: 4,
          location_name: "Black pokea",
          location_color: "#egxewd",
          latitude: "25.258863321225963",
          longitude: "55.365180433851215",
          status: "enabled",
        },
        {
          staff_geofence_work_locations_id: 4,
          location_name: "Black pokea",
          location_color: "#egxewd",
          latitude: "25.258863321225963",
          longitude: "55.365180433851215",
          status: "enabled",
        },
        {
          staff_geofence_work_locations_id: 4,
          location_name: "Black pokea",
          location_color: "#egxewd",
          latitude: "25.258863321225963",
          longitude: "55.365180433851215",
          status: "enabled",
        },
      ],
    },
  ];

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {/* {pageLoading && <Loader />} */}
        <div className="content">
          <div className="contentHeader d-flex align-items-center gap-3 pb-3">
            <div className="contentDiv">
              <Breadcrumb className="contentTitle">
                <Breadcrumb.Item active>Work Locations</Breadcrumb.Item>
                <Breadcrumb.Item active>Assign Locations</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <Box
                className="workLocaionMainBox"
                sx={{ background: "#f4f6f8", minHeight: "100vh" }}
              >
                {/* Header Section */}

                {/* Date Navigation */}
                {/* <Box
                  className="date-nav"
                  position="relative"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={2}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    width="200px"
                    justifyContent="flex-start"
                  >
                    <Tooltip title="Add location to the staff">
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ fontSize: "12px", padding: "2px 6px" }}
                        onClick={() => handleAddStaffWithShift()}
                        disabled={selectedAddShiftUsers.length !== 0}
                      >
                        Add Staff
                      </Button>
                    </Tooltip>
                  </Box>
                </Box> */}

                {/* Shift Table */}
                <Card elevation={4}>
                  <CardContent className="shift-card">
                    <Box
                      className="scrollable-plan-section"
                      sx={{ overflowX: "auto", width: "100%" }}
                    >
                      <Box
                        sx={{
                          display: "inline-block", // Let it expand based on its children
                          minWidth: "100%", // Ensures full width used but allows scroll
                        }}
                      >
                        {/* Table Header */}
                        <Grid
                          container
                          spacing={1}
                          className="shift-table-header"
                        >
                          <Grid item xs={3} display="flex">
                            {/* <Checkbox
                          checked={
                            selectedAddShiftUsers.length ===
                              shiftDetailsData.length &&
                            shiftDetailsData.length > 0
                          }
                          onChange={(e) => handleSelectAll(e.target.checked)}
                          sx={{ marginTop: "-12px" }}
                        /> */}
                            <h4
                              className="shiftTableHeader"
                              style={{ margin: 0 }}
                            >
                              STAFF NAME
                            </h4>
                          </Grid>

                          {/* Replace date headers with location headers */}
                          <Grid item xs={7}>
                            <Grid container spacing={1}>
                              <Grid item xs sx={{ textAlign: "center" }}>
                                <h4 className="shiftTableHeader">
                                  ASSIGNED LOCATIONS
                                </h4>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        {/* Employee Rows */}
                        {loading ? (
                          <>
                            {[...Array(10)].map((_, i) => (
                              <Box key={i} sx={{ marginBottom: 2 }}>
                                <Shimmer width="100%" height="40px" />
                              </Box>
                            ))}
                          </>
                        ) : (
                          <Box
                            sx={{
                              maxHeight: "calc(100vh - 220px)",
                              overflowY: "auto",
                              paddingRight: "5px",
                            }}
                          >
                            {shiftDetails.length > 0 ? (
                              shiftDetails.map((user, index) => (
                                <Grid
                                  container
                                  spacing={1}
                                  alignItems="center"
                                  key={index}
                                  className="shift-user-row"
                                >
                                  {/* Staff Info */}
                                  <Grid item xs={3} className="employeeMainDiv">
                                    <Box
                                      className="employee-info"
                                      sx={{ marginLeft: "0px" }}
                                    >
                                      {/* <Checkbox
                                  sx={{ padding: "0px" }}
                                  checked={selectedAddShiftUsers.some(
                                    (selectedUser) =>
                                      selectedUser.staff_id === user.staff_id
                                  )}
                                  onChange={(e) =>
                                    handleUserCheck(user, e.target.checked)
                                  }
                                /> */}
                                      <Avatar
                                        className="employee-avatar"
                                        src={
                                          user?.user_profile || userDummyImage
                                        }
                                        onError={(e) => {
                                          e.preventDefault();
                                          e.target.onerror = null;
                                          e.target.setAttribute(
                                            "src",
                                            userDummyImage
                                          );
                                        }}
                                      >
                                        {user?.user_name
                                          ?.charAt(0)
                                          .toUpperCase()}
                                      </Avatar>
                                      <Box>
                                        <Typography
                                          variant="subtitle2"
                                          sx={{
                                            fontWeight: 600,
                                            color: "#0e2241",
                                            marginLeft: "5px",
                                          }}
                                        >
                                          {user.user_name}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Grid>

                                  {/* Location Cells */}
                                  <Grid item xs={7}>
                                    {user.location_details &&
                                    user.location_details.length > 0 ? (
                                      <>
                                        {Array.from(
                                          {
                                            length: Math.ceil(
                                              user.location_details.length / 3
                                            ),
                                          },
                                          (_, rowIndex) => {
                                            const start = rowIndex * 3;
                                            const rowItems =
                                              user.location_details.slice(
                                                start,
                                                start + 3
                                              );

                                            return (
                                              <Grid
                                                container
                                                spacing={1}
                                                key={rowIndex}
                                              >
                                                {rowItems.map((loc, i) => (
                                                  <Grid
                                                    item
                                                    xs={
                                                      rowItems.length === 1
                                                        ? 12
                                                        : 4
                                                    }
                                                    key={i}
                                                  >
                                                    <Box
                                                      sx={{
                                                        backgroundColor:
                                                          loc.location_color,
                                                        borderRadius: 2,
                                                        padding: "8px",
                                                        textAlign: "center",
                                                        fontWeight: 600,
                                                        marginBottom: "10px",
                                                        color: "#fff",
                                                        boxShadow:
                                                          "0 2px 6px rgba(0,0,0,0.1)",
                                                      }}
                                                    >
                                                      {loc.location_name}
                                                    </Box>
                                                  </Grid>
                                                ))}
                                              </Grid>
                                            );
                                          }
                                        )}
                                      </>
                                    ) : (
                                      <Box
                                        sx={{
                                          width: "100%",
                                          minHeight: "30px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          backgroundColor: "#f8f9fa",
                                          borderRadius: 2,
                                          color: "#888",
                                          fontWeight: 500,
                                          textAlign: "center",
                                        }}
                                      >
                                        No locations assigned
                                      </Box>
                                    )}
                                  </Grid>

                                  <Grid item sx={{ ml: "auto" }}>
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      sx={{
                                        minWidth: "unset",
                                        fontSize: "11px",
                                        padding: "2px 6px",
                                        lineHeight: 1.2,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        marginRight: "10px",
                                      }}
                                      onClick={() => handleEditShift(user)}
                                    >
                                      <i
                                        className="fas fa-map-marker-alt"
                                        style={{ fontSize: "12px" }}
                                      ></i>
                                      Assign
                                      <br />
                                      Location
                                    </Button>
                                  </Grid>
                                </Grid>
                              ))
                            ) : (
                              <Box
                                sx={{
                                  width: "100%",
                                  textAlign: "center",
                                  padding: "10px",
                                  color: "#999",
                                  fontWeight: 500,
                                  fontSize: "16px",
                                  border: "1px dashed #ccc",
                                  borderRadius: 2,
                                  marginTop: "10px",
                                }}
                              >
                                No data available
                              </Box>
                            )}
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Box>

              <Dialog
                open={addShiftOpen}
                onClose={() => setAddShiftOpen(false)}
                fullWidth={false}
                maxWidth={false}
                PaperProps={{
                  sx: {
                    width: "600px", // Change to "200px" if needed
                    borderRadius: 2,
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    background: "#2d64bc",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "1.25rem",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    padding: "16px 24px",
                  }}
                >
                  <i className="fas fa-clock" style={{ fontSize: 18 }}></i>
                  <span style={{ fontSize: 16, paddingTop: "3px" }}>
                    Select Work Location
                  </span>
                </DialogTitle>

                <DialogContent
                  sx={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    paddingBottom: 2,
                    zIndex: "auto", // optional
                  }}
                >
                  <FormControl fullWidth margin="dense">
                    <Select
                      labelId="shift-label"
                      multiple
                      value={selectedShiftIds}
                      open={isDropdownOpen}
                      onOpen={() => setIsDropdownOpen(true)}
                      onClose={() => setIsDropdownOpen(false)}
                      onChange={(e) => setSelectedShiftIds(e.target.value)}
                      renderValue={(selectedIds) => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {selectedIds.map((id) => {
                            const shift = workShiftTemplates.find(
                              (s) =>
                                s.geofence_work_location_templates_id === id
                            );
                            return (
                              <Chip
                                key={id}
                                label={shift?.location_name || ""}
                                sx={{ fontSize: "14px" }}
                              />
                            );
                          })}
                        </Box>
                      )}
                      size="small"
                      MenuProps={{
                        disablePortal: true, // ✅ this is the key
                        PaperProps: {
                          style: {
                            maxHeight: 188,
                            zIndex: 1200, // optional, but can help
                          },
                        },
                      }}
                    >
                      {workShiftTemplates.map((shift) => (
                        <MenuItem
                          key={shift.geofence_work_location_templates_id}
                          value={shift.geofence_work_location_templates_id}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Checkbox
                            checked={selectedShiftIds.includes(
                              shift.geofence_work_location_templates_id
                            )}
                          />
                          <ListItemText primary={`${shift.location_name}`} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </DialogContent>

                <DialogActions
                  sx={{
                    padding: "16px 24px",
                    position: "sticky",
                    bottom: 0,
                    background: "#fff",
                    borderTop: "1px solid #ccc",
                    ...(isDropdownOpen && { marginTop: "175px" }),
                    zIndex: 1501,
                  }}
                >
                  <Button
                    onClick={() => {
                      setAddShiftOpen(false);
                      setSelectedShift([]);
                      setSelectedShiftIds([]);
                    }}
                    color="inherit"
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSaveShift}
                    disabled={selectedShiftIds.length === 0}
                    variant="contained"
                  >
                    Save
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={editShiftOpen}
                onClose={() => setEditShiftOpen(false)}
                fullWidth
                maxWidth={false}
                PaperProps={{
                  sx: {
                    width: "600px", // or "200px"
                  },
                }}
              >
                <DialogTitle
                  sx={{
                    background: "#2d64bc",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "1.25rem",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    padding: "16px 24px",
                  }}
                >
                  <i className="fas fa-clock" style={{ fontSize: 18 }}></i>
                  <span style={{ fontSize: 18, paddingTop: "3px" }}>
                    Select Work Location
                  </span>
                </DialogTitle>

                <DialogContent
                  sx={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    paddingBottom: 2,
                    zIndex: "auto", // optional
                  }}
                >
                  <FormControl fullWidth margin="dense">
                    <Select
                      labelId="shift-label"
                      multiple
                      value={selectedShiftIds}
                      open={isDropdownOpen}
                      onOpen={() => setIsDropdownOpen(true)}
                      onClose={() => setIsDropdownOpen(false)}
                      onChange={(e) => setSelectedShiftIds(e.target.value)}
                      renderValue={(selectedIds) => (
                        <Box
                          sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                        >
                          {selectedIds.map((id) => {
                            const shift = workShiftTemplates.find(
                              (s) =>
                                s.geofence_work_location_templates_id === id
                            );
                            return (
                              <Chip
                                key={id}
                                label={shift?.location_name || ""}
                                sx={{ fontSize: "14px" }}
                              />
                            );
                          })}
                        </Box>
                      )}
                      size="small"
                      MenuProps={{
                        disablePortal: true, // ✅ this is the key
                        PaperProps: {
                          style: {
                            maxHeight: 188,
                            zIndex: 1200, // optional, but can help
                          },
                        },
                      }}
                    >
                      {workShiftTemplates.map((shift) => (
                        <MenuItem
                          key={shift.geofence_work_location_templates_id}
                          value={shift.geofence_work_location_templates_id}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Checkbox
                            checked={selectedShiftIds.includes(
                              shift.geofence_work_location_templates_id
                            )}
                          />
                          <ListItemText primary={`${shift.location_name}`} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </DialogContent>

                <DialogActions
                  sx={{
                    padding: "16px 24px",
                    position: "sticky",
                    bottom: 0,
                    background: "#fff",
                    borderTop: "1px solid #ccc",
                    ...(isDropdownOpen && { marginTop: "175px" }),
                    zIndex: 1501,
                  }}
                >
                  <Button
                    onClick={() => {
                      setEditShiftOpen(false);
                      setSelectedShift([]);
                      setSelectedShiftIds([]);
                    }}
                    color="inherit"
                    variant="outlined"
                  >
                    Cancel
                  </Button>
                  <Button
                    // disabled={selectedShiftIds.length === 0}
                    onClick={() => {
                      handleUpdateShift(); // your update logic
                      setIsDropdownOpen(false); // ✅ manually close dropdown
                      setEditShiftOpen(false); // ✅ close the dialog if needed
                    }}
                    variant="contained"
                  >
                    Save
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={confirmDialogOpen}
                onClose={() => setConfirmDialogOpen(false)}
              >
                <DialogTitle
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    padding: "10px 24px",
                    fontSize: "1.1rem",
                  }}
                >
                  {actionType === "publish"
                    ? `Confirm Shifts Publication`
                    : `Confirm Shifts Lock`}
                </DialogTitle>
                <DialogContent dividers>
                  <Typography variant="body2" color="textSecondary">
                    {actionType === "publish"
                      ? `Please confirm if you would like to publish the shifts for this week.
                        Review all shift details carefully before proceeding.`
                      : `Please confirm if you would like to lock the shifts for this week.
                      Once locked, staff members will no longer be able to edit their shifts for this period.`}
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setConfirmDialogOpen(false)}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      publishOrLockShiftsAPI(actionType);
                      setConfirmDialogOpen(false);
                    }}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={confirmCreateShiftDialogOpen}
                onClose={() => setConfirmCreateShiftDialogOpen(false)}
              >
                <DialogTitle
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    padding: "10px 24px",
                    fontSize: "1.1rem",
                  }}
                >
                  Confirm Shifts Creation
                </DialogTitle>
                <DialogContent dividers>
                  {/* <Typography variant="body1" sx={{ mb: 1 }}>
                    Are you sure you want to create the shift?
                  </Typography> */}
                  <Typography variant="body2" color="textSecondary">
                    Please confirm if you would like to create the shifts.
                    Review the override option, date range, and shift details
                    carefully. This action cannot be undone once confirmed.
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setConfirmCreateShiftDialogOpen(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      createDefaultShiftAPI(pendingShiftData); // 👈 Use stored data
                      setConfirmCreateShiftDialogOpen(false);
                      setCreateShiftOpen(false); // close shift dialog too
                    }}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={infoDialogOpen}
                onClose={() => setInfoDialogOpen(false)}
              >
                <DialogTitle
                  sx={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    padding: "10px 24px",
                    fontSize: "1.1rem",
                  }}
                >
                  Information
                </DialogTitle>
                <DialogContent dividers>
                  Shifts are already {actionType}ed.
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setInfoDialogOpen(false)} autoFocus>
                    OK
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle
                  sx={{
                    fontWeight: "bold",
                    bgcolor: "#2d64bc",
                    color: "white",
                  }}
                >
                  Add Location for Staff
                </DialogTitle>

                <DialogContent dividers sx={{ bgcolor: "#fafafa" }}>
                  <Box sx={{ mb: 2, marginLeft: "28px", fontWeight: 600 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isAllSelected}
                          onChange={(e) =>
                            handleStaffSelectAll(e.target.checked)
                          }
                        />
                      }
                      label="Select All Staff"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontWeight: 600,
                        },
                      }}
                    />
                  </Box>
                  <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 1 }}>
                    {staffList.map((staff) => (
                      <Paper
                        key={staff.staff_id}
                        elevation={2}
                        sx={{
                          p: 2,
                          mb: 2,
                          borderRadius: 2,
                          backgroundColor: "#fff",
                        }}
                      >
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={1}>
                            <Checkbox
                              checked={selectedAddStaff.includes(
                                staff.staff_id
                              )}
                              onChange={() =>
                                handleStaffCheckboxChange(staff.staff_id)
                              }
                            />
                          </Grid>

                          <Grid
                            item
                            xs={11}
                            container
                            spacing={2}
                            alignItems="center"
                          >
                            <Grid item xs={12} sm={4}>
                              <Typography
                                variant="body1"
                                fontWeight="600"
                                sx={{ color: "#0e2241", fontSize: "1rem" }}
                              >
                                {staff.user_name}
                              </Typography>
                            </Grid>

                            <Grid item xs={12} sm={8}>
                              <FormControl fullWidth>
                                <InputLabel sx={{ fontSize: "1rem" }}>
                                  Shift
                                </InputLabel>
                                <Select
                                  value={
                                    assignedShifts[staff.staff_id]?.shiftId ||
                                    ""
                                  }
                                  onChange={(e) =>
                                    handleShiftChange(
                                      staff.staff_id,
                                      e.target.value
                                    )
                                  }
                                  label="Shift"
                                  MenuProps={{
                                    PaperProps: {
                                      style: { maxHeight: 120 },
                                    },
                                  }}
                                >
                                  {workShiftTemplates.map((shift) => (
                                    <MenuItem
                                      key={shift.user_shift_templates_id}
                                      value={shift.user_shift_templates_id}
                                    >
                                      {shift.shift_name} ({shift.start_time} -{" "}
                                      {shift.end_time})
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>

                            {/* <Grid
                              item
                              xs={12}
                              sm={4}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "20px",
                              }}
                            >
                              <InputLabel>Can Edit Shifts?</InputLabel>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={
                                      assignedShifts[staff.staff_id]?.canEdit ||
                                      false
                                    }
                                    onChange={(e) =>
                                      handleEditToggle(
                                        staff.staff_id,
                                        e.target.checked
                                      )
                                    }
                                  />
                                }
                              />
                            </Grid> */}
                          </Grid>
                        </Grid>
                      </Paper>
                    ))}
                  </Box>
                </DialogContent>

                <DialogActions sx={{ p: 2, bgcolor: "#f5f5f5" }}>
                  <Button
                    onClick={() => {
                      setOpen(false);
                      setSelectedAddStaff([]);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={selectedAddStaff.length === 0}
                  >
                    Assign
                  </Button>
                </DialogActions>
              </Dialog>

              <Dialog
                open={createShiftOpen}
                onClose={() => setCreateShiftOpen(false)}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle
                  sx={{
                    fontWeight: "bold",
                    bgcolor: "#2d64bc",
                    color: "white",
                  }}
                >
                  Create Shifts for Staff
                </DialogTitle>

                <DialogContent dividers sx={{ bgcolor: "#fafafa" }}>
                  {/* Override Switch & Date Range */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ px: 3, pb: 2 }}
                  >
                    {/* Override Existing Shifts */}
                    <FormControlLabel
                      control={
                        <Switch
                          checked={overrideShifts}
                          onChange={(e) => setOverrideShifts(e.target.checked)}
                        />
                      }
                      label="Override Existing Shifts"
                      sx={{ fontWeight: 600 }}
                    />

                    {/* Date Range */}
                    <Box>
                      <Tooltip title="Choose Date Range">
                        <Typography
                          onClick={() => setShowDatePicker(!showDatePicker)}
                          sx={{
                            cursor: "pointer",
                            color: "#0e2241",
                            fontSize: "1rem",
                            fontWeight: 550,
                          }}
                        >
                          {formatDate(dateRange[0].startDate)} -{" "}
                          {formatDate(dateRange[0].endDate)}{" "}
                          <span className="dateIcon">
                            <i className="fa-solid fa-calendar-days"></i>
                          </span>
                        </Typography>
                      </Tooltip>

                      {showDatePicker && (
                        <div
                          className="modal fade show"
                          id="dateRangeModal"
                          tabIndex="-1"
                          aria-labelledby="dateRangeModalLabel"
                          aria-hidden="false"
                          role="dialog"
                          style={{
                            display: "block",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                          }}
                        >
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content dateRangeModal">
                              <div className="modal-header">
                                <h5
                                  className="modal-title"
                                  id="dateRangeModalLabel"
                                >
                                  Choose Date Range
                                </h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  onClick={handleCloseDatePicker}
                                  aria-label="Close"
                                ></button>
                              </div>
                              <div className="modal-body">
                                <DateRangePicker
                                  onChange={
                                    (item) => setTempDateRange([item.selection]) // Store temporary selection
                                  }
                                  showSelectionPreview={true}
                                  moveRangeOnFirstSelection={false}
                                  months={2}
                                  ranges={tempDateRange} // Use temporary state for preview
                                  direction="horizontal"
                                  minDate={addDays(new Date(), 1)}
                                  inputRanges={[]}
                                  staticRanges={customStaticRanges}
                                />
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-success deleteYesBtn"
                                  onClick={handleApplyDatePicker}
                                >
                                  Apply
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-danger deleteNoBtn"
                                  onClick={handleCloseDatePicker}
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </Box>
                  </Box>

                  {/* Select All Checkbox */}
                  <Box sx={{ mb: 2, marginLeft: "28px", fontWeight: 600 }}>
                    {/* <FormControlLabel
                      control={
                        <Checkbox
                          checked={isAllSelected}
                          onChange={(e) =>
                            handleStaffSelectAll(e.target.checked)
                          }
                        />
                      }
                      label="Select All Staff sasa"
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontWeight: 600,
                        },
                      }}
                    /> */}
                  </Box>

                  {/* Staff List with Shift Select */}
                  <Box sx={{ maxHeight: 400, overflowY: "auto", pr: 1 }}>
                    {selectedAddShiftUsers.map((staff) => (
                      <Paper
                        key={staff.staff_id}
                        elevation={2}
                        sx={{
                          p: 2,
                          mb: 2,
                          borderRadius: 2,
                          backgroundColor: "#fff",
                        }}
                      >
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={12} sm={4}>
                            <Typography
                              variant="body1"
                              fontWeight="600"
                              sx={{ color: "#0e2241", fontSize: "1rem" }}
                            >
                              {staff.user_name}
                            </Typography>
                          </Grid>

                          {/* Spacer */}
                          <Grid
                            item
                            xs={0}
                            sm={1}
                            display={{ xs: "none", sm: "block" }}
                          />

                          <Grid item xs={12} sm={7}>
                            <FormControl fullWidth>
                              <InputLabel sx={{ fontSize: "1rem" }}>
                                Shift
                              </InputLabel>
                              <Select
                                value={
                                  assignedCreateShifts[staff.staff_id]
                                    ?.shiftId || ""
                                }
                                onChange={(e) =>
                                  handleCreateShiftChange(
                                    staff.staff_id,
                                    e.target.value
                                  )
                                }
                                label="Shift"
                                MenuProps={{
                                  PaperProps: {
                                    style: { maxHeight: 120 },
                                  },
                                }}
                              >
                                {workShiftTemplates.map((shift) => (
                                  <MenuItem
                                    key={shift.user_shift_templates_id}
                                    value={shift.user_shift_templates_id}
                                  >
                                    {shift.shift_name} ({shift.start_time} -{" "}
                                    {shift.end_time})
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Paper>
                    ))}
                  </Box>
                </DialogContent>

                {/* Actions */}
                <DialogActions sx={{ p: 2, bgcolor: "#f5f5f5" }}>
                  <Button onClick={() => setCreateShiftOpen(false)}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCreateShiftSubmit}
                    disabled={selectedAddShiftUsers.length === 0}
                  >
                    Create Shift
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignLocationToStaff;
